import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet-async";
import {
  FaFacebookF,
  FaInstagram,
} from "react-icons/fa";
import './Footer.css';

const SOCIAL_LINKS = [
  {
    id: 'facebook',
    url: 'https://www.facebook.com/people/Specijalistička-veterinarska-praksa-Dr-Pezo/100063764791742/',
    icon: FaFacebookF,
    label: 'Facebook veterinarska ordinacija Zagreb',
    className: 'facebook'
  },
  {
    id: 'instagram',
    url: 'https://www.instagram.com/dr.pezoveterinar',
    icon: FaInstagram,
    label: 'Instagram veterinar Zagreb',
    className: 'instagram'
  }
];

const FOOTER_LINKS = [
  { to: '/kontakt', label: 'Kontakt' },
  { to: '/politika-privatnosti', label: 'Politika privatnosti' }
];

function Footer() {
  return (
    <footer className='footer-container'>
      <Helmet>
        <meta name="author" content="Veterinarska ordinacija Zagreb" />
      </Helmet>

      <section className='footer-subscription'>
        <p className='footer-subscription-heading'>
          Pratite nas na društvenim mrežama
        </p>

        <div className='social-icons'>
          {SOCIAL_LINKS.map((social) => {
            const Icon = social.icon;
            return (
              <a
                key={social.id}
                className={`social-icon-link ${social.className}`}
                href={social.url}
                target='_blank'
                rel='noopener noreferrer'
                aria-label={social.label}
              >
                <Icon />
              </a>
            );
          })}
        </div>
      </section>

      <div className='footer-bottom-wrapper'>
        <div className='footer-bottom'>
          <div className="footer-links-wrapper">
            {FOOTER_LINKS.map((link) => (
              <Link key={link.to} to={link.to} className="footer-link">
                {link.label}
              </Link>
            ))}
          </div>
        </div>
        <div className="footer-copyright">
          <small className='website-rights'>
            &copy; 2026 Filip Antunović. Sva prava pridržana.
          </small>
        </div>
      </div>
    </footer>
  );
}

export default Footer;